import { Compass, ClipboardCheck, Search, BarChart3, PenTool, Users } from "lucide-react";

const map = {
  compass: Compass,
  clipboard: ClipboardCheck,
  search: Search,
  chart: BarChart3,
  pen: PenTool,
  users: Users,
};

export const ServiceIcon = ({ name, size = 22, className = "text-ser-purple" }) => {
  const Icon = map[name] || Compass;
  return <Icon size={size} strokeWidth={1.5} className={className} aria-hidden="true" />;
};
